import React from "react";
import { ReactComponent as SuccessIcon } from "../../assets/icons/success.svg";
import { ReactComponent as WarningIcon } from "../../assets/icons/warning.svg";
import { ReactComponent as ErrorIcon } from "../../assets/icons/error.svg";

const ICONS_BY_TYPE = {
  success: SuccessIcon,
  error: ErrorIcon,
  warning: WarningIcon,
};

const ToastIcon = ({ type }) => {
  const Icon = ICONS_BY_TYPE[type];

  if (!Icon) return null;

  return <Icon width={22} height={22} style={{ flexShrink: 0 }} />;
};

export default ToastIcon;
